import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectTenantsOverview, CommonProjectTenantsTopics } from "../../CommonComponents/CommonProjectTenantsView";
export const ProjectTenantsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().tenants,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTenantsOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTenantsTopics />;
    },
};
